import { Button } from "@/components/ui/button";
import { chipClass } from "@/components/badge/chip";
import { useToast } from "@/hooks/use-toast";
import { cn } from "@/lib/utils";

// PRD short ID chip (`CCP-42`): click copies it — for branch names, PR
// titles and saying it out loud. Renders nothing until the home app has a key.
export const CopyShortId = ({
  shortId,
  className,
}: {
  shortId?: string | null;
  className?: string;
}) => {
  const { toast } = useToast();
  if (!shortId) return null;
  const copy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(shortId).then(
      () => toast({ title: "ID copied", description: shortId }),
      () => toast({ variant: "destructive", title: "Copy failed" })
    );
  };
  return (
    <Button
      variant="ghost"
      size="xs"
      onClick={copy}
      title="Copy ID"
      aria-label={`Copy ${shortId}`}
      className={chipClass(
        "neutral",
        cn("font-mono font-normal tabular-nums hover:bg-primary/10 hover:text-primary", className)
      )}
    >
      {shortId}
    </Button>
  );
};
